import { render, staticRenderFns } from "./ManualMatching.vue?vue&type=template&id=7401fe90"
import script from "./ManualMatching.vue?vue&type=script&lang=js"
export * from "./ManualMatching.vue?vue&type=script&lang=js"
import style0 from "./ManualMatching.vue?vue&type=style&index=0&id=7401fe90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports